import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Layout.css";

const Layout = ({ children, agentData, onLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const FOUR_HOURS = 4 * 60 * 60 * 4000;
  useEffect(() => {
    // check immediately
    checkExpiry();

    // check periodically (short timer – mobile safe)
    const interval = setInterval(checkExpiry, 60 * 1000); // every 1 min

    // check when tab becomes active again
    const onVisibilityChange = () => {
      if (!document.hidden) checkExpiry();
    };

    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  const checkExpiry = () => {
    const loginTime = Number(localStorage.getItem("loginTime"));
    // console.log("Checking session expiry...", { loginTime, currentTime: Date.now() });

    if (!loginTime) {
      onLogout();
      return;
    }

    if (Date.now() - loginTime >= FOUR_HOURS) {
      localStorage.removeItem("agentData");
      onLogout();
    }
  };

  const menuItems = [
    { path: "/dashboard", icon: "📊", label: "Dashboard" },
    { path: "/clients", icon: "👥", label: "Clients" },
    { path: "/payouts", icon: "💰", label: "Payouts" },
  ];

  const isActive = (path) => location.pathname === path;

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className='sl-agent-layout-wrapper'>
      {/* Mobile Header */}
      <div className='sl-agent-mobile-header'>
        <button className='sl-agent-menu-btn' onClick={toggleSidebar} aria-label='Toggle menu'>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className='sl-agent-mobile-logo'>
          <div className='sl-agent-mobile-logo-icon'>
            <img
              style={{
                width: "100%",
              }}
              src='https://res.cloudinary.com/ebuka1122/image/upload/v1752244790/StorelenseLogos/StorelenseLogo_tqya01.webp'
              alt='StoreLense Logo'
            />
          </div>
          <span>
            <b
              style={{
                color: "#0F49B5",
              }}
            >
              Store
            </b>
            <b
              style={{
                color: "#3BB4C4",
              }}
            >
              Lense
            </b>
          </span>
        </div>
        <div className='sl-agent-mobile-spacer'></div>
      </div>

      {/* Sidebar */}
      <aside className={`sl-agent-sidebar ${sidebarOpen ? "sl-agent-sidebar-open" : ""}`}>
        <div className='sl-agent-sidebar-header'>
          <div className='sl-agent-sidebar-logo'>
            <div className='sl-agent-sidebar-logo-icon'>
              <img
                style={{
                  width: "100%",
                }}
                src='https://res.cloudinary.com/ebuka1122/image/upload/v1752244790/StorelenseLogos/StorelenseLogo_tqya01.webp'
                alt='StoreLense Logo'
              />
            </div>
            <div className='sl-agent-sidebar-logo-text'>
              <h2>
                <b
                  style={{
                    color: "#0F49B5",
                  }}
                >
                  Store
                </b>
                <b
                  style={{
                    color: "#3BB4C4",
                  }}
                >
                  Lense
                </b>
              </h2>
              <span>Agent Portal</span>
            </div>
          </div>
        </div>

        <nav className='sl-agent-sidebar-nav'>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`sl-agent-nav-item ${isActive(item.path) ? "sl-agent-nav-active" : ""}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className='sl-agent-nav-icon'>{item.icon}</span>
              <span className='sl-agent-nav-label'>{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className='sl-agent-sidebar-footer'>
          <div className='sl-agent-profile-card'>
            <div className='sl-agent-profile-avatar'>{agentData?.agentName?.charAt(0) || "A"}</div>
            <div className='sl-agent-profile-info'>
              <h4>{agentData?.agentName || "Agent"}</h4>
              <p>{agentData?.agentEmail || ""}</p>
            </div>
          </div>
          <button className='sl-agent-logout-btn' onClick={onLogout}>
            <span>🚪</span>
            Logout
          </button>
        </div>
      </aside>

      {/* Overlay for mobile */}
      {sidebarOpen && <div className='sl-agent-sidebar-overlay' onClick={() => setSidebarOpen(false)}></div>}

      {/* Main Content */}
      <main className='sl-agent-main-content'>
        <div className='sl-agent-content-container'>{children}</div>
      </main>
    </div>
  );
};

export default Layout;
